module.exports = __webpack_public_path__ + "img/tip2.f2da3617.png";